<template>
  <div class="container">
    <div style="display: flex; height: calc(100vh - 168px);">
      <div style="height: 100%; overflow-y: auto; background-color: #dfdfe2;" v-loading="organsInLevels.length === 0">
        <el-tree :data="organsInLevels"
                 :expand-on-click-node="false"
                 default-expand-all
                 @current-change="currentChange"
                 node-key="key"
                 ref="organ"
                 style="width: 280px; background-color: transparent; padding: 10px 10px 0 0"
                 class="organ">
          <template #default="{ data }">
            <div :class="{'selected' : selectedOrganData === data}">{{ data.label }}</div>
          </template>
        </el-tree>
        <div style="cursor: not-allowed; position: absolute; left: 100px; width: 220px; background-color: darkgrey"></div>
      </div>

      <div style="width: calc(100% - 220px); height: 100%;">
        <div>
          <el-button type="primary" v-if="!isEdit" style="width: 100%" @click="edit">编辑</el-button>
          <div v-else style="display: flex">
            <el-button type="primary" @click="save" style="flex-grow: 1">保存</el-button>
            <el-button @click="cancel" style="flex-grow: 1; margin-left: 1px">取消</el-button>
          </div>
        </div>
        <div style="height: calc(100% - 32px); overflow-y: auto; box-sizing: border-box;" class="table-border-no-top">
          <el-tree :data="pagePermissionTree"
                   :expand-on-click-node="false"
                   default-expand-all
                   :show-checkbox="isEdit"
                   node-key="id"
                   ref="permission"
                   style="background-color: transparent; padding: 20px;">
            <template #default="{ data }">
              <div style="cursor: pointer; margin-left: 10px">
                <template v-if="pagePermissions.has(data.id)">
                  <div style="color: blue; font-weight: bold">
                    <i class="el-icon-check" style="margin-right: 10px"></i>
                    <label style="">{{ data.label }}</label>
                  </div>
                </template>
                <template v-else>
                  <label>{{ data.label }}</label>
                </template>
              </div>
            </template>
          </el-tree>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { allOrgansInLevels, pagePermissionTree, updatePagePermissions } from '@/utils/request'

  export default {
    name: 'PagePermission',
    data () {
      return {
        organsInLevels: [],
        selectedOrganData: {},
        pagePermissionTree: [],
        isEdit: false
      }
    },
    created () {
      allOrgansInLevels().then(response => {
        this.organsInLevels.push(response.data)
        this.$nextTick(() => {
          this.$refs.organ.setCurrentKey(response.data.key)
          this.currentChange(response.data)
        })
      })
      pagePermissionTree().then(response => {
        this.pagePermissionTree = response.data
      })
    },
    methods: {
      currentChange (data) {
        if (this.isEdit && this.selectedOrganData && data.key !== this.selectedOrganData.key) {
          this.$refs.organ.setCurrentKey(this.selectedOrganData.key)
          this.$alert('正在编辑中，不能切换机构!', {
            confirmButtonText: '确定'
          }).catch(() => {
          })
        } else {
          this.selectedOrganData = data
        }
      },
      edit () {
        this.isEdit = true
        if (this.selectedOrganData.pagePermissions) {
          this.$refs.permission.setCheckedKeys(this.selectedOrganData.pagePermissions)
        } else {
          this.$refs.permission.setCheckedKeys([])
        }
      },
      save () {
        const pagePermissions = this.$refs.permission.getCheckedKeys()
        updatePagePermissions(
          this.selectedOrganData.id,
          this.selectedOrganData.type,
          pagePermissions).then(() => {
          this.selectedOrganData.pagePermissions = pagePermissions
          this.isEdit = false
          this.$message.success('更新成功!')
        })
      },
      cancel () {
        this.isEdit = false
      }
    },
    computed: {
      pagePermissions () {
        if (!this.selectedOrganData) {
          return new Set()
        }
        return new Set(this.selectedOrganData.pagePermissions)
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ {
    .el-tree-node__content {
      height: 28px;
    }

    .el-tree-node__label {
      font-size: 15px;
    }

    .organ {
      .selected,
      .el-tree-node__content:hover,
      .el-tree-node:focus > .el-tree-node__content {
        color: white;
        background-color: #1890ff;
        border-radius: 4px;
      }
    }

    th {
      height: 50px;
    }
  }
</style>
